import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setMaxVal,
  setOptJustificatif,
  setPac,
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";

export const VacancesNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm }) => {
  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7,
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [valParticipation, setValParticipation] = useState(0);
  const [enfants, setEnfants] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();
  const [ibanMembre, setIbanMembre] = useState(null);
  const [enfantsAgeIntervalle, setEnfantsAgeIntervalle] = useState({});
  const [displayError, setDisplayError] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();

  const linkService = new LinkProviderService();

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";

  if (!actionSociale || !actionSociale.cas || !actionSociale.exercice || actionSociale.listActionsSociale.length === 0) {
    history.push("/choixPeriodeVacances/"+actionSociale.cas);
  }

  useEffect(() => {
    getCurrentActionSociale();
    if(actionSociale.fiche.siNoFiche){
            setDisplayError(prevState => [...prevState, errors.exercice]);
    }else if(!actionSociale.fiche.siDodEncours) {

            if((actionSociale.exercice > actionSociale.fiche.exerciceDod) && !displayError.includes(errors.exercice)) { setDisplayError(prevState => [...prevState, errors.exercice]) }
            if((!actionSociale.fiche.droits.prestationSansCr || actionSociale.fiche.statutDod == '4') && !displayError.includes(errors.droits)) { setDisplayError(prevState => [...prevState, errors.droits]) }
            if(actionSociale.fiche?.statutDod) {
              if(actionSociale.fiche.statutDod !== '3' && !displayError.includes(errors.statut)) { setDisplayError(prevState => [...prevState, errors.statut]) }
              else if(!actionSociale.fiche.droits.prestationSansCr && !displayError.includes(errors.qf)) { setDisplayError(prevState => [...prevState, errors.qf]) }
            } else if(!displayError.includes(errors.dod)) {
               setDisplayError(prevState => [...prevState, errors.dod]);
            }
            if(!actionSociale.fiche.siDossierValide && !displayError.includes(errors.siDossierValide)){
              setDisplayError(prevState => [...prevState, errors.siDossierValide]);
            }

    }
    getIsJustificatifRequis();
    getIbanMembre();
    getAgentEnfants();
  }, []);

  useEffect(() => {
    dispatch(setOptJustificatif(isJustificatifRequis));
  }, [isJustificatifRequis]);

  useEffect(() => {
    dispatch(setMaxVal(valParticipation));
  }, [valParticipation]);

  useEffect(() => {
    dispatch(setIban(ibanMembre));
  }, [ibanMembre]);

  useEffect(() => {
    dispatch(setPac(enfants));
  }, [enfants]);

  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (
        as.codeActionSociale === actionSociale.cas &&
        as.exercice === actionSociale.exercice
      ) {
        setCurrentActionSociale(as);
        getBaremes(as);
        getEnfantsAgeIntervalle(as);
        return;
      }
    });
  };

  //4) Recuperration des baremes
  const getBaremes = async (actionSocial) => {
    const bareme = {
      casCode: actionSocial.codeActionSociale,
      delegId: actionSocial.codeDelegation,
      exercie: actionSocial.exercice,
      siActif: 1,
    };

    try {
      const { data } = await clapService.getBaremes(bareme);
      setBaremes(data);
      getValeurParticipation(data);
      if(actionSocial.fiche) await getIsJustificatifRequis();
    } catch (error) {
      console.log(error);
    }
  };

  const getValeurParticipation = (tranches) => {
    let val = 0;
    tranches.forEach((el, i) => {
      if (val !== 0) return;

      if (i === tranches.length - 1) {
        if (Number(actionSociale.fiche.quotientFamilial) >= Number(el.borne)) {
          val = tranches[i].valeur;
        }
      } else if (Number(actionSociale.fiche.quotientFamilial) < Number(tranches[i + 1].borne)) {
        val = el.valeur;
      }
      if(actionSociale.fiche.quotientFamilial == null){
        val = tranches[tranches.length-1].valeur;
      }
      setValParticipation(val);
    });
  };

  const getIsJustificatifRequis = async () => {
    try {
      const { data } = await clapService.getJustificatifForClapNoticeInfo(
          actionSociale.fiche.numCgos,
          actionSociale.fiche.codeSituationAdministrative,
          actionSociale.fiche.codePosition
      );
      setIsJustificatifRequis(data);
    } catch (error) {
      console.log(error);
    }
  };

  //Récuperation de l'IBAN de l'agent
  const getIbanMembre = async () => {
    try {
      const { data } = await clapService.getIbanMembre(user.numCgos);
      setIbanMembre(data.numIBan);
      if(!actionSociale.fiche.siDodEncours){
       if(!data.numIBan && !displayError.includes(errors.iban)) setDisplayError(prevState => [...prevState, errors.iban]);
      }
    } catch (error) {
      setDisplayError(prevState => [...prevState, errors.iban])
    }
  };

  const getAgentEnfants = () => {
    // Il n'ya pas de vérification d'enfants pour la prestation vavances adultes et familles (cas = 3823)
    if(actionSociale.cas === "3323"){
      agentService.getAgentEnfants(actionSociale.fiche.numCgos, actionSociale.fiche.codeDelegation, actionSociale.cas, actionSociale.exercice).then((res) => {
        let items = [];
        res.data.forEach((e) => items.push(e));
        setEnfants(items);        
          if(items.length === 0 && !displayError.includes(errors.pac)) setDisplayError(prevState => [...prevState, errors.pac]);        
      }).catch((err) => {
        setDisplayError(prevState => [...prevState, errors.pac]);
      });
    }
  };

  const getEnfantsAgeIntervalle = async (actionSocial) => {
    try {
      const { data } = await agentService.getEnfantsParamIntervalle(
          actionSocial.codeDelegation,
          actionSocial.codeActionSociale,
          actionSocial.exercice
      );
      setEnfantsAgeIntervalle(data);
    } catch (error) {
      console.log(error);
    }
 };

  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };

  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" }}>
           {actionSociale.fiche.siDodEncours && (

              <div className="alert alert-success" style={{textAlign:"center"  }}>
                <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif" }}>Votre dossier C.G.O.S { actionSociale.exercice } est en cours de traitement.<b> Votre demande de prestation sera étudiée après l’ouverture de vos droits.</b> <p>Votre quotient familial sera calculé si vous avez joint votre avis d’impôt sur les revenus.</p></span>
              </div>
           )}
           {(displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide) ) && (
                         <div className="alert alert-danger" style={{textAlign:"center"  }}>
                          <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif"}}>Vous ne pouvez pas demander cette prestation car <b>le contenu ou le statut actuel de votre dossier C.G.O.S ne le permet pas ou pas encore.</b> <p> Actualisez votre dossier depuis la rubrique
                                                     <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> Dossier C.G.O.S en ligne</a>. </p><p> {textAdressezVous}<a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank"> contact C.G.O.S</a></p> </span>
                                                   </div>
            )}
{/*           {(displayError.includes(errors.dod))  && (
              <div className="alert alert-danger">
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>Le statut actuel de votre dossier C.G.O.S { actionSociale.exercice } ne vous permet pas d’accéder aux formulaires de demande de prestations. Consultez et ou actualisez le statut de votre dossier depuis la rubrique
                <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> Dossier C.G.O.S en ligne</a>.</span>
              </div>
          )} */}
          {(displayError.includes(errors.statut) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits) )) && (
              <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>Vous devez
                <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> compléter votre dossier annuel C.G.O.S</a> en ligne pour pouvoir accéder à cette demande de prestation.</span>
              </div>
          )}
          {(displayError.includes(errors.qf) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits))) && (
              <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                <a href={linkService.getRetourEaMembreDroits()} target="_blank">Vos droits</a> ouverts pour l'année {actionSociale.exercice} ne vous permettent pas d’accéder aux prestations versées selon le quotient familial C.G.O.S.
            </span>
              </div>
          )}
          {displayError.includes(errors.iban) && (
            <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                Vous ne pouvez pas demander cette prestation car <b>vous n’avez pas fourni de relevé d’identité bancaire (IBAN) au C.G.O.S.</b>
                <p>Nous vous invitons à nous l’adresser depuis la rubrique
                <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank">
                  {" "}« Nous contacter - Changement de situation »{" "}
                 </a></p>
              </span>
            </div>
          )}
          {(displayError.includes(errors.pac) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits) ))&& (
            <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                Vous ne pouvez pas demander cette prestation car <b>il n’y a pas d’enfants enregistrés ou éligibles dans votre dossier C.G.O.S</b> de l’année concernée.
                <p> S’il s’agit d’une erreur, adressez-vous à votre
                <a href={linkService.getRetourEaContacterNous()} target="_blank">
                  {" "}contact C.G.O.S{" "}
                </a></p>
              </span>
            </div>
          )}

         {currentActionSociale?.codeActionSociale == "3323" &&
          
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
            Le C.G.O.S verse une prestation pour participer aux dépenses <b>avec hébergement</b> occasionnées par les vacances prises par mes enfants/adolescents, 
            <b> dans des structures agréées</b>, en France ou à l'étranger.
              <ul>
                <li>
                  Classes de découverte, culturelle, de neige de mer, verte, voyage scolaire.
                </li>
                <li>
                  Séjours linguistiques, éducatif, culturel.
                </li>
                <li>
                  Centre de vacances agrée, camp, séjour à thème, stage sportif.
                </li>
              </ul>
            </span>
          }
          {currentActionSociale?.codeActionSociale == "3323" &&
           <h2 className="cld-h2">Bénéficiaires</h2>
          }
          {currentActionSociale?.codeActionSociale == "3323" &&
          <p>Mon enfant:</p>
          }
          {currentActionSociale?.codeActionSociale == "3323" &&
          <ul>
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              <li>
                Doit avoir entre {enfantsAgeIntervalle.minValue} ans et moins de {enfantsAgeIntervalle.maxValue} ans au 1 er janvier de l’année concernée.
              </li>
              <li>
                 S'il est en situation de handicap avec un taux supérieur ou égal à 80%, il n'est pas concerné par l'âge limite.
              </li>
              <li>
                 Peut être à ma charge fiscale, en résidence alternée, ou non à ma charge fiscale si je suis séparé ou divorcé.
              </li>
              </span>
          </ul>}

          {currentActionSociale?.codeActionSociale == "3823" &&
          
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Le C.G.O.S verse une prestation pour participer aux dépenses occasionnées par les vacances seul(e) ou en famille, en France ou à l'étranger : 
              <ul>  
              <li>
                Dans des <b>structures agréées</b> (location, camping-caravaning, hôtel, résidence hôtelière, séjour, circuit, croisière),
              </li>
              <ul>  
                <li>
                    Prise en compte des locations sans intermédiaires ou par le biais de diffuseurs d'annonces.
                </li>
                <li>
                    Les locations de particulier à particulier doivent faire l'objet d'un référencement/enregistrement du particulier auprès de l'Office du tourisme.
                </li>
                <li>
                   <b>Incluant un hébergement d'au moins une nuit</b>.
                </li>
              </ul>                          
              <li>
                  Ou pour des frais de transports collectifs (avion, train, bateau, bus, van et camping-car).
              </li>
              </ul>
              </span>
          }

          <h2 className="cld-h2">Montants versés</h2>
          <p className="cld-p">
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Le montant maximum annuel de la prestation dépend de mon quotient familial et des frais dépensés.
              <p>Ces frais ne peuvent pas être inférieurs à 30 euros.</p>
              {currentActionSociale?.codeActionSociale == "3323" &&
              <p>Je peux effectuer une ou plusieurs demandes par an, dans la limite du montant annuel maximum par enfant.</p>
              }
              {currentActionSociale?.codeActionSociale == "3823" &&
              <p>Je peux effectuer une ou plusieurs demandes par an, dans la limite du montant annuel maximum.</p>
              }
            </span>
          </p>

          {actionSociale.fiche.siDodEncours && (
          <div className="cld-p">
            <ul>
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
              <p></p>
              <li>
                <b>Tant que vos droits ne sont pas ouverts</b>, le <b>quotient familial</b> affiché <b>est</b> <b>« non connu »</b> car pas encore calculé.<br></br>
                Si tel est le cas, <b>vous pouvez quand même envoyer votre demande</b> sans cette information. <br></br>
                Votre QF et le montant de la participation du C.G.O.S seront automatiquement mis à jour avant l'étude de votre demande.
              </li>
              </span>
            </ul>
          </div>
           )}

          <table className="cld-table">
            <thead>
              <tr>
                <th>Tranche de quotient familial de référence</th>
                {currentActionSociale?.codeActionSociale == "3323" &&
                  <th>Montant annuel maximum par enfant</th>
                }
                {currentActionSociale?.codeActionSociale == "3823" &&
                  <th>Montant annuel maximum de la participation du CGOS</th>
                }
              </tr>
            </thead>
            <tbody>
              {baremes.map((el, i) => {
                let borne = "";
                 if (i >= 0 && i < baremes.length - 1) {
                  const borneToNumber = Number(baremes[i + 1].borne).toFixed(0);
                  borne = `de ${el.borne} à ${borneToNumber}`;
                } else {
                  borne = `supérieur à ${Number(el.borne).toFixed(
                    0
                  )} ou non connu`;
                }
                return (
                  <tr key={i}>
                    <td>{borne}</td>
                    <td>{el.valeur} €</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <p></p>
          {!actionSociale.fiche.siDodEncours && (
          <table className="cld-table-2">
            <thead>
              <tr>
                <th>Mon quotient familial</th>
                {currentActionSociale?.codeActionSociale == "3323" &&
                  <th>Montant annuel maximum par enfant</th>
                }
                {currentActionSociale?.codeActionSociale == "3823" &&
                  <th>Montant annuel maximum de la participation du CGOS</th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {actionSociale.fiche.quotientFamilial == null? "non connu" : actionSociale.fiche.quotientFamilial.toString().replace('.', ',')}
                </td>
                <td>
                  {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].valeur : valParticipation} €
                </td>
              </tr>
            </tbody>
          </table>
          )}
          <div className="info-wrapper">
            <span
              style={{
                fontSize: "12.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Documents à préparer pour ma demande
            </span>
          </div>

          {currentActionSociale?.codeActionSociale == "3823" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Vacances avec séjour dans un établissement commercial (hôtel, auberge, complexe touristique, etc.)
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture, reçu ou attestation officielle du séjour avec hébergement établie par l'organisme agréé à mon nom et faisant apparaître le montant payé et les
                        dates de début et de fin du séjour.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
           {currentActionSociale?.codeActionSociale == "3823" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Vacances avec location entre particuliers
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture, reçu ou attestation à mon nom et faisant apparaître le montant payé et les dates de début et de fin du séjour avec hébergement et le montant
                        de la taxe de séjour (ou à défaut de taxe de séjour, une attestation de l’office du tourisme attestant que le loueur est référencé).
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )} 
            {currentActionSociale?.codeActionSociale == "3823" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Frais de transports collectifs (avion, train, bateau, bus, van et camping-car)
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture ou reçu à mon nom et faisant apparaitre le montant payé et les dates de transport.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )} 
          {currentActionSociale?.codeActionSociale == "3323" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                  <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture, reçu ou attestation du séjour avec hébergement
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                       Etablie par l'organisme agréé, à mon nom et où apparaît le nom et le prénom de mon enfant, 
                       le coût et les dates de début et de fin du séjour.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
             )}
            
          {isJustificatifRequis && (
            <div class="card-justificatif">
              <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                  <img src="/assets/image/DOC.png" />
                </div>
                <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                  <div class="card-justificatif-titre pt-2">
                    <span
                      style={{
                        fontSize: "9.0pt",
                        fontFamily: "Tahoma, sans-serif",
                      }}
                    >
                      Justificatif de présence en établissement
                    </span>
                  </div>
                  <div className="card-justificatif-description">
  <ul
    style={{
      listStyleType: "disc",
      listStylePosition: "inside",
      padding: 0,
      margin: 0,
      fontSize: "9.0pt",
      fontFamily: "Tahoma, sans-serif",
    }}
  >
    <li style={{ marginBottom: "4px" }}>
      Bulletin de paie ou attestation de travail de moins d’un mois.
    </li>
    <li>
      Décision administrative de congés parental à 100%.
    </li>
  </ul>
</div>


                </div>
              </div>
            </div>
          )}
          <div className="tutorial">
            <img className="tutorial-image" src="/assets/icon_youtube.png" />{" "}
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
            >
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
                # TutorielCGOS - Comment scanner un document
              </span>
            </a>
          </div>
          <div className="info-wrapper">
            <span
              style={{
                fontSize: "12.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Comment m'y prendre
            </span>
          </div>
          <p className="cld-c">
          <p>Ma demande : </p>{" "}
          <ul>
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              <li>
                <b>Doit être envoyée après la date de fin du séjour indiquée sur la facture</b>,
              </li>
              <li>
                Doit être envoyée après avoir transmis mon Dossier C.G.O.S annuel (c’est indispensable pour le calcul des droits),
              </li>
              {currentActionSociale?.codeActionSociale == "3323" &&<li>
                Doit concerner un seul enfant à la fois,
              </li>}
              <li>
                Peut être envoyée en une seule fois pour toute l’année ou en plusieurs fois durant l’année,
              </li>
              <li>
                Peut être envoyée jusqu’au  {getDateFormat(currentActionSociale.dateFin)} de l’année suivant celle de mes dépenses,
              </li>
              <li>
                <b>Sera étudiée après l'ouverture de mes droits</b>
              </li>
            </span>
          </ul>
          </p>
          {!hiddenButton && (
            <div className="cld-dem">
              <br></br>
              <h1
                style={{
                  color: "#676767",
                  fontWeight: "bold",
                  fontSize: "15.0pt",
                  fontFamily: "Tahoma, sans-serif",
                  textAlign: "center",
                }}
              >
                CETTE DEMARCHE PREND 5 MINUTES
              </h1>
              <br></br>
              <div className="next-button-wrapper">
                 { displayError.length > 0
                                 ? <button type="button" className="disabled" style={{ pointerEvents: "none" }}> ENVOYER UNE DEMANDE EN LIGNE </button>
                                 : <button type="button" className="btn_submit_modal" onClick={nextStep}> ENVOYER UNE DEMANDE EN LIGNE </button>}
              </div>
              <br></br>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
